import { render, staticRenderFns } from "./leftNavbar.vue?vue&type=template&id=347c256a&scoped=true&"
import script from "./leftNavbar.vue?vue&type=script&lang=js&"
export * from "./leftNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347c256a",
  null
  
)

export default component.exports